import jwtDecode from "jwt-decode";
import { MenuAccess } from "./menuOptions";
export interface DecodenToken {
	Id: string;
	SellerId: string;
	UserRoleId: string;
	userRole: string;
	MenuOptions: string;
	exp: string;
}
export const ACCESS_TOKEN = "token";

export const getUserRoleFromToken = () => {
	const token = localStorage.getItem(ACCESS_TOKEN);
	if (!token) {
		return false;
	}
	try {
		const decodedToken = jwtDecode(token) as DecodenToken;
		const userRoleId = decodedToken.UserRoleId;
		return parseInt(userRoleId);
	} catch (error) {
		return false;
	}
};

export const getUserMenuOptionsFromToken = () => {
	const token = localStorage.getItem(ACCESS_TOKEN);
	if (!token) {
		return null;
	}
	try {
		const decodedToken = jwtDecode(token) as DecodenToken;
		const menuOptions = decodedToken?.MenuOptions?.split(",");
		return menuOptions as MenuAccess[] | null;
	} catch (error) {
		return null;
	}
};

export const getUserIdFromToken = () => {
	const token = localStorage.getItem(ACCESS_TOKEN);
	if (!token) {
		return false;
	}
	try {
		const decodedToken = jwtDecode(token) as DecodenToken;
		const userId = decodedToken.Id;
		return parseInt(userId);
	} catch (error) {
		return false;
	}
};

export const getSellerIdFromToken = () => {
	const token = localStorage.getItem(ACCESS_TOKEN);
	if (!token) {
		return false;
	}
	try {
		const decodedToken = jwtDecode(token) as DecodenToken;
		const sellerId = decodedToken.SellerId;
		return parseInt(sellerId);
	} catch (error) {
		return false;
	}
};
export const getTokenExpirationDate = (): Date | null => {
	const token = localStorage.getItem(ACCESS_TOKEN);
	if (!token) {
		return null;
	}

	try {
		const decodedToken = jwtDecode(token) as DecodenToken;
		const expSeconds = parseInt(decodedToken.exp, 10);

		if (isNaN(expSeconds)) {
			return null;
		}

		const expirationDate = new Date(expSeconds * 1000);
		return expirationDate;
	} catch (error) {
		return null;
	}
};

export function isTokenExpiringBeyond8Days(): boolean {
	const expDate = getTokenExpirationDate();
	if (!expDate) return false;

	const now = new Date();
	const diffInMs = expDate.getTime() - now.getTime();
	const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

	return diffInDays > 8;
}
